import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import Sidebar from './Sidebar';
import { SupportChatWidget } from './SupportChatWidget';

const Layout = ({ children, variant = 'dark' }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-deep-navy">
      <div className="hidden lg:flex">
        <Sidebar />
      </div>

      {mobileNavOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="h-full overflow-y-auto" style={{ backgroundColor: '#07090c' }} onClick={(e) => e.stopPropagation()}>
            <Sidebar />
          </div>
          <div className="flex-1 bg-black/60" onClick={() => setMobileNavOpen(false)}>
            <button className="m-3 p-2 rounded-lg bg-card-bg border border-divider text-white" aria-label="Close menu" data-testid="mobile-nav-close">
              <X size={20} />
            </button>
          </div>
        </div>
      )}

      <main className={`flex-1 overflow-auto ${variant === 'light' ? 'light-theme bg-[#f5f6f1]' : ''}`}>
        <div className="lg:hidden sticky top-0 z-40 flex items-center justify-between px-4 py-3 backdrop-blur border-b border-white/10" style={{ backgroundColor: 'rgba(7,9,12,0.95)' }}>
          <span className="text-lg font-bold text-white">GritClicks<span className="text-lime">.com</span></span>
          <button onClick={() => setMobileNavOpen(true)} className="p-2 rounded-lg border border-divider text-white" aria-label="Open menu" data-testid="mobile-nav-toggle">
            <Menu size={20} />
          </button>
        </div>
        <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
          {children}
        </div>
      </main>
      <SupportChatWidget />
    </div>
  );
};

export default Layout;
